/** Digits only from a PhoneInput / free-text phone value. */
export const phoneDigitsOnly = (value) => String(value || "").replace(/\D/g, "");

/**
 * PhoneInput fills the dial code when a country is selected (e.g. "1", "30").
 * Treat those as empty until the user types a real number.
 * Country calling codes are at most 3 digits.
 */
export const hasMeaningfulPhone = (value) => phoneDigitsOnly(value).length > 3;

/** Optional phone: empty / dial-code-only is OK; otherwise need >= 7 digits. */
export const isOptionalPhoneValid = (value) =>
  !hasMeaningfulPhone(value) || phoneDigitsOnly(value).length >= 7;

/** Required phone: must have at least 7 digits. */
export const isRequiredPhoneValid = (value) => phoneDigitsOnly(value).length >= 7;

/** API payload: `+digits` or null when empty / dial-code-only. */
export const formatPhoneForApi = (value) => {
  if (!hasMeaningfulPhone(value)) return null;
  return `+${phoneDigitsOnly(value)}`;
};
